import React from 'react';
import * as LucideIcons from 'lucide-react';
import { Button } from './Button';
import { cn } from '@/utils/cn';

export interface EmptyStateProps {
  icon?: React.ReactNode | string;
  title: string;
  description?: string;
  action?: {
    label: string;
    onClick: () => void;
  };
  className?: string;
}

export function EmptyState({
  icon,
  title,
  description,
  action,
  className = '',
}: EmptyStateProps) {
  const renderIcon = () => {
    if (!icon) return null;

    if (typeof icon === 'string') {
      const IconComponent = (LucideIcons as unknown as Record<string, React.ComponentType<{ className?: string }>>)[icon];
      if (IconComponent) {
        return (
          <div className="w-16 h-16 rounded-full bg-muted flex items-center justify-center mb-4">
            <IconComponent className="w-8 h-8 text-muted-foreground" />
          </div>
        );
      }
    }

    return (
      <div className="mb-4 text-muted-foreground">
        {icon}
      </div>
    );
  };

  return (
    <div className={cn('flex flex-col items-center justify-center py-12 px-4 text-center', className)}>
      {renderIcon()}
      <h3 className="text-lg font-semibold text-foreground mb-2">{title}</h3>
      {description && (
        <p className="text-sm text-muted-foreground max-w-sm mb-6">{description}</p>
      )}
      {action && (
        <Button onClick={action.onClick}>
          {action.label}
        </Button>
      )}
    </div>
  );
}
